import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Store from '../../stores/Store'
import { FormSelect } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import Input from './Input'

@observer
class Select extends Component {
  static propTypes = {
    ...FormSelect.propTypes,
    options: FormSelect.propTypes.options,
    store: PropTypes.instanceOf(Store).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func, // could be useful if you want to parse value to form value
    onAfterChanged: PropTypes.func
  }

  static defaultProps = {
    errorPointing: 'above'
  }

  constructor (props) {
    super(props)
    const { store, name } = this.props
    // we need to init the value to default before rendering
    store.get(name, null)
  }

    handleOnChangeInput = (e, data) => {
      const { store, castValue, onAfterChanged } = this.props
      const value = castValue ? castValue(data.value) : data.value
      store.set(data.name, value)
      store.resetErrorMessageField(data.name)
      if (onAfterChanged) {
        onAfterChanged()
      }
    }

    render () {
      const {
        store,
        defaultValue,
        name,
        options,
        onChange,
        castValue,
        parseValue,
        errorPointing,
        error,
        readOnly,
        onAfterChanged,
        ...props
      } = this.props
      const value = store.get(name, defaultValue ?? '')
      const valueError = store.getErrorMessageField(name)
      if (readOnly) {
        const valueText = options.find(option => option.value === value).text
        return <Input {...this.props} value={valueText} />
      }

      return (
        <FormSelect
          key={name}
          options={options}
          value={parseValue ? parseValue(value) : value}
          name={name}
          error={valueError ? { content: valueError, pointing: errorPointing } : error}
          onChange={onChange || this.handleOnChangeInput}
          {...props}
        />
      )
    }
}
export default Select
